"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  small: 639,
  medium: 1023,
  large: 1600,
  xlarge: 2048
};
exports.default = _default;